import { Form, Input, Space, Typography, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from '../styledComponent';

const { Title, Text } = Typography;

function EnquiryInformationCard() {
  const { t } = useTranslation();

  return (
    <Card
      id="enquiry-information"
      title={
        <Space align="center" size="middle">
          <Title level={3} type="secondary">
            {1}
          </Title>
          <Title level={4}>{t('benefits.surgery.enquiryInformation')}</Title>
        </Space>
      }
    >
      <CardBody gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Form.Item
            name="surgery"
            label={<Text>{t('benefits.surgery.surgeryFormTitle')}</Text>}
            rules={[{ required: true, message: t('registration.error.required') }]}
          >
            <Input placeholder={t('benefits.surgery.surgeryPlaceholder')} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="diagnosis"
            label={<Text>{t('benefits.surgery.diagnosisFormTitle')}</Text>}
            rules={[{ required: true, message: t('registration.error.required') }]}
          >
            <Input placeholder={t('benefits.surgery.diagnosisPlaceholder')} />
          </Form.Item>
        </Col>
      </CardBody>
    </Card>
  );
}

export default EnquiryInformationCard;
